import React from 'react';

interface IconProps {
    fill?: string;
    width?: number;
    height?: number;
}

export const TaskDelete = ({ fill = '#757575', width = 14, height = 14 }: IconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 14 14"
        fill="none"
    >
        <path
            d="M13.125 2.33333H10.0625V1.16667C10.0625 0.857247 9.93344 0.560501 9.70371 0.341709C9.47397 0.122916 9.16239 0 8.8375 0L5.1625 0C4.83761 0 4.52603 0.122916 4.29629 0.341709C4.06656 0.560501 3.9375 0.857247 3.9375 1.16667V2.33333H0.875V3.5H2.1V12.25C2.1 12.7141 2.29359 13.1592 2.63819 13.4874C2.98279 13.8156 3.45016 14 3.9375 14H10.0625C10.5498 14 11.0172 13.8156 11.3618 13.4874C11.7064 13.1592 11.9 12.7141 11.9 12.25V3.5H13.125V2.33333ZM5.1625 1.16667H8.8375V2.33333H5.1625V1.16667ZM10.675 12.25C10.675 12.4047 10.6105 12.5531 10.4956 12.6625C10.3807 12.7719 10.2249 12.8333 10.0625 12.8333H3.9375C3.77505 12.8333 3.61926 12.7719 3.5044 12.6625C3.38953 12.5531 3.325 12.4047 3.325 12.25V3.5H10.675V12.25Z"
            fill={fill}
        />
        <path d="M6.47486 5.83276H5.42487V10.4994H6.47486V5.83276Z" fill={fill} />
        <path d="M8.57534 5.83276H7.52533V10.4994H8.57534V5.83276Z" fill={fill} />
    </svg>
);
